module.exports = __webpack_public_path__ + "img/peopleNum.5840d5ec.png";